/**
 * loginReturn (VH-293) — the way back to a session report after a new login.
 *
 * The report page sends the login page its own address; the login page goes
 * back there only when the address is a report page and the person logging in
 * is the one whose login had ended. Anything else is the start page, so the
 * login can never be used to send someone to an arbitrary address.
 */
import { LOGIN_USER_KEY, LOGOUT_REASON_EXPIRED, LOGOUT_REASON_IDLE, LOGOUT_REASON_KEY } from './authKeys'

const REPORT_PATH = /^\/capture\/session\/[A-Za-z0-9_-]+$/

const read = (key) => {
  try {
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

/** The report page the login was opened from, if it is one. */
export function safeReturnPath(path) {
  return typeof path === 'string' && REPORT_PATH.test(path) ? path : null
}

/** Whose login ended here (string id), or null. */
export function rememberedUserId() {
  return read(LOGIN_USER_KEY)
}

/** True when a login on this device ended without a chosen log-out. */
export function loginEnded() {
  const reason = read(LOGOUT_REASON_KEY)
  return (reason === LOGOUT_REASON_IDLE || reason === LOGOUT_REASON_EXPIRED) && rememberedUserId() != null
}

/** Where to go after a login: back to the report page, or the start page. */
export function pathAfterLogin(returnTo, previousUserId, user) {
  const path = safeReturnPath(returnTo)
  if (!path || previousUserId == null || String(user?.id) !== String(previousUserId)) return '/'
  return path
}
